import { render, staticRenderFns } from "./CarryingAFamilyLegacyTowardGrowthStability.vue?vue&type=template&id=349660ea&scoped=true"
import script from "./CarryingAFamilyLegacyTowardGrowthStability.vue?vue&type=script&lang=js"
export * from "./CarryingAFamilyLegacyTowardGrowthStability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349660ea",
  null
  
)

export default component.exports